import { render, staticRenderFns } from "./ResearchStudentSave.vue?vue&type=template&id=6bc157fc&"
import script from "./ResearchStudentSave.vue?vue&type=script&lang=js&"
export * from "./ResearchStudentSave.vue?vue&type=script&lang=js&"
import style0 from "./ResearchStudentSave.vue?vue&type=style&index=0&id=6bc157fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports